"use strict";

exports.__esModule = true;
exports.shouldForwardProp = exports.defaultSystemProps = void 0;

var _shared = _interopRequireDefault(require("./shared"));

exports.defaultSystemProps = _shared["default"];

var _utils = _interopRequireDefault(require("./utils"));

exports.shouldForwardProp = _utils["default"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }